<mat-tab-group
  class="sub-tab-xdr"
  animationDuration="0ms"
  (selectedTabChange)="selectedTabChange($event)">

  <mat-tab label="Current"></mat-tab>
  <mat-tab label="Last 4 Hrs"></mat-tab>
  <mat-tab label="Last 24 Hrs"></mat-tab>
  <mat-tab label="Last 7 Days"></mat-tab>
  <mat-tab label="This Month"></mat-tab>
  <mat-tab label="Last Month"></mat-tab>
</mat-tab-group>

<div class="charts-grid">
  <app-pie-graph title="Traffic by Domain"   [data]="pieService"></app-pie-graph>
  <app-pie-graph title="Traffic by Service"    [data]="pieDomain"></app-pie-graph>
  <app-pie-graph title="Traffic by Interface" [data]="pieIface"></app-pie-graph>
  <app-pie-graph title="Traffic by Source IP" [data]="pieSrcIp"></app-pie-graph>
  <app-pie-graph title="Traffic by Dest IP"   [data]="pieDstIp"></app-pie-graph>
</div>
